import { useIsEditorContext } from "@editor-providers";
import { LinkPopUp, useIsPdf } from "@library/components";
import { type MouseEventHandler, type ReactNode, useState } from "react";
import type { IconProps } from "../types";

const Link = ({
  children,
  settings,
}: {
  children: ReactNode;
  settings: IconProps;
}) => {
  const isEditor = useIsEditorContext();
  const isPdf = useIsPdf();
  const [showLinkPopUp, setShowLinkPopUp] = useState(false);
  const handleOnClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (isEditor || !settings.linkUrl) return e.preventDefault();
    if (
      isPdf ||
      !(settings.selectedLinkType === "hyperlink" && settings.openInPopup)
    )
      return;
    e.preventDefault();
    setShowLinkPopUp(true);
  };

  if (
    (settings.isLinkActive && !settings.selectedLinkType) ||
    settings.selectedLinkType === "hyperlink"
  ) {
    return (
      <>
        <a
          href={settings.linkUrl}
          target={"_blank"}
          onClick={handleOnClick}
          rel="noreferrer"
          aria-label={settings.ariaLabel || ""}
          className="tw-flex !tw-no-underline [align-items:inherit] [justify-content:inherit]"
        >
          {children}
        </a>
        {showLinkPopUp && (
          <LinkPopUp
            src={settings.linkUrl}
            closePopUp={() => setShowLinkPopUp(false)}
          />
        )}
      </>
    );
  }
  return (
    <div className="icon-rV35NqKoHsiNVN4--wrapper tw-flex [align-items:inherit] [justify-content:inherit]">
      {children}
    </div>
  );
};

export default Link;
